'use client';
import React from 'react';
import Link from 'next/link';
import { Button } from '@fagmobler/ui';

const Custom404 = () => {
  return (
    <div className="text-center py-52">
      <h1 className="hd-8xl">404</h1>
      <p className="body-md mb-10">
        Beklager! Siden ser ikke ut til å eksistere.
      </p>
      <Link legacyBehavior href="/">
        <Button>Gå tilbake til forsiden</Button>
      </Link>
    </div>
  );
};

export default Custom404;
